export default () => {
    const form = document.getElementById('getMoreInfo');
    form.addEventListener('submit', (event) => {
        //event.preventDefault();
        //submit actions here
        //form.reset();
    });
};
